// engagementConstants.js
'use strict';

export const PlayerType = {
  LIVESTREAM: 'livestream',
  VOD: 'vod',
};

export const GiftState = {
  BEFORE_SEND_GIFT: 'before_send_gift',
  AFTER_SEND_GIFT: 'after_send_gift',
};
